import React from "react";

export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6" data-testid={testid}>
      <div>
        <h1 className="font-display text-3xl sm:text-4xl text-brand-ink leading-tight">{title}</h1>
        {subtitle && <p className="text-brand-mutedFg mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, body, action, testid }) {
  return (
    <div className="card p-10 text-center" data-testid={testid}>
      {Icon && (
        <div className="w-12 h-12 rounded-full bg-brand-muted mx-auto flex items-center justify-center text-brand-ink mb-4">
          <Icon size={20} strokeWidth={1.5} />
        </div>
      )}
      <h3 className="font-display text-xl text-brand-ink">{title}</h3>
      {body && <p className="text-brand-mutedFg mt-1 max-w-md mx-auto">{body}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Stat({ label, value, hint, accent }) {
  return (
    <div className="card p-5">
      <div className="label">{label}</div>
      <div className="font-display text-3xl mt-2 text-brand-ink">{value}</div>
      {hint && <div className={`text-sm mt-1 ${accent || "text-brand-mutedFg"}`}>{hint}</div>}
    </div>
  );
}

export function Spinner({ label = "Loading…" }) {
  return (
    <div className="flex items-center gap-2 text-brand-mutedFg">
      <span className="inline-block w-3 h-3 rounded-full border-2 border-brand-ink border-t-transparent animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
